// extracted by mini-css-extract-plugin
export default {"history-messages":"styles_history-messages__LZ-tU"};